'use client'

import type { ReactNode } from 'react'

import { Link } from '@b-stock/fe-core/bstock-react'

import { trackSignUpStart } from '@/helpers/telemetry/trackSignUpStart'

type SignupTrackedLinkProps = {
  href: string
  children: ReactNode
  signUpCtaLocation: string
  target?: string
  rel?: string
}

/** Caller must pass an `href` already validated as a signup account URL. */
export function SignupTrackedLink({
  href,
  children,
  signUpCtaLocation,
  target,
  rel,
}: SignupTrackedLinkProps) {
  return (
    <Link
      href={href}
      onClick={() => trackSignUpStart(signUpCtaLocation)}
      {...(target ? { target, rel: rel ?? 'noopener noreferrer' } : {})}
    >
      {children}
    </Link>
  )
}
